import { JobListItem } from '@/components/features/JobList/JobListItem';
import { PrefectureValue } from '@/constants/prefectures';
import { Button } from '@/components/common/Button/Button';
import { useTranslations } from 'next-intl';
import { JobListDocument } from '../gen/graphql/JobsRoute.generated';
import { useSuspenseQuery } from '@apollo/client';
import { Link } from '@/i18n/navigation';
import { useTransition } from 'react';

export interface JobListProps {
  prefCode: PrefectureValue | undefined;
  jobCrewCategoryId: string | undefined;
  jobBenefitId: string | undefined;
}

// TODO: Empty state and loading state
export function JobList({ prefCode, jobCrewCategoryId, jobBenefitId }: JobListProps) {
  const t = useTranslations('common');

  const { data, fetchMore } = useSuspenseQuery(JobListDocument, {
    variables: {
      first: 20,
      prefCodes: prefCode && [prefCode],
      jobCrewCategoryIds: jobCrewCategoryId && [jobCrewCategoryId],
      jobBenefitIds: jobBenefitId && [jobBenefitId],
    },
    fetchPolicy: 'cache-first',
  });

  const [isPending, startTransition] = useTransition();

  const jobs =
    data?.fastTimelineJobs.edges?.map((edge) => edge?.node).filter((value) => !!value) ?? [];

  const hasNext = data?.fastTimelineJobs.pageInfo.hasNextPage;

  const handleClickMore = () => {
    if (!hasNext) {
      return;
    }

    startTransition(() => {
      void fetchMore({
        variables: {
          after: data?.fastTimelineJobs.pageInfo.endCursor,
        },
      });
    });
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        {jobs.map((node, index) => (
          <div
            key={node.id}
            className={index < jobs.length - 1 ? 'border-b-thin border-neutral-auxiliary pb-4' : ''}
          >
            <Link href={`/jobs/${node.id}`}>
              <JobListItem job={node} />
            </Link>
          </div>
        ))}
      </div>
      {hasNext && (
        <div className="flex justify-center">
          {/* TODO: loading state */}
          <Button
            variant="filled"
            colorScheme="primary"
            size="medium"
            className="w-full pc:w-[360px]"
            onClick={handleClickMore}
            loading={isPending}
          >
            {t('action.loadMore')}
          </Button>
        </div>
      )}
    </div>
  );
}
